<template>
  <div class="bienvenida-page">
    
    <p class="versiculo-referencia-fija" ref="versiculoRef"></p>

    <div class="bienvenida-container">
      <div class="contenido-bienvenida">
        
        <div class="mensaje-bienvenida" ref="mensajeRef">
          {{ mensaje }}
        </div>

        <div class="versiculo-container" ref="versiculoTextRef">
         <p class="versiculo-texto">
  <br><br><br>
<br><br>
  <span class="letra-quince">16 years ago</span> my story began, 
  a journey full of laughter, lessons, and shared dreams.

  <br><br>

  Today, that journey brings me here… to this very special day, 
  where I celebrate not only my life, but also the love of those who have been with me every step of the way.

  <br><br>

  This invitation is a window into my heart, 
  and I’m excited that you are here to be part of it.

  <br><br>

  Welcome to an unforgettable chapter of this story that is just beginning.

  <br><br>
</p>
        </div>

      </div>
    </div>

    <div class="disco-group disco3-group">
    </div>

  </div>
</template>

<script>
import { ref, onMounted } from 'vue'
import { gsap } from 'gsap'

export default {
  name: 'BienvenidaPage',
  setup() {
    const mensaje = ref('')

    const mensajeRef = ref(null)
    const versiculoTextRef = ref(null)
    const versiculoRef = ref(null)

    const disco1Ref = ref(null)
    const disco2Ref = ref(null)
    const disco3Ref = ref(null)
    const estrella3Ref = ref(null)

    const animateOnScroll = (el, animationFn) => {
      if (!el) return

      const observer = new IntersectionObserver(
        ([entry]) => {
          if (entry.isIntersecting) {
            animationFn()
            observer.unobserve(el)
          }
        },
        { threshold: 0.3 }
      )
      observer.observe(el)
    }

    onMounted(() => {
      animateOnScroll(mensajeRef.value, () =>
        gsap.fromTo(mensajeRef.value, 
          { opacity: 0, y: 50 }, 
          { opacity: 1, y: 0, duration: 1 }
        )
      )

      animateOnScroll(versiculoTextRef.value, () =>
        gsap.fromTo(versiculoTextRef.value, 
          { opacity: 0, y: 40 }, 
          { opacity: 1, y: 0, duration: 1 }
        )
      )

      animateOnScroll(versiculoRef.value, () =>
        gsap.fromTo(versiculoRef.value, 
          { opacity: 0, y: 20 }, 
          { opacity: 1, y: 0, duration: 1 }
        )
      )

      const animateDisco = (discoEl, delay = 0) => {
        gsap.fromTo(
          discoEl,
          { opacity: 0, y: -150, scale: 0.9 },
          { 
            opacity: 1, 
            y: 0, 
            scale: 1, 
            duration: 1.1, 
            delay,
            ease: "bounce.out" 
          }
        )
      }

      animateOnScroll(disco1Ref.value, () => animateDisco(disco1Ref.value))
      animateOnScroll(disco2Ref.value, () => animateDisco(disco2Ref.value, 0.2))
      animateOnScroll(disco3Ref.value, () => animateDisco(disco3Ref.value, 0.4))
    })

    return {
      mensaje,
      mensajeRef,
      versiculoTextRef,
      versiculoRef,
      disco1Ref,
      disco2Ref,
      disco3Ref,
      estrella3Ref
    }
  }
}
</script>

<style scoped>
.bienvenida-page {
  background:#f3f7fd;
  color: black;
  min-height: 50vh;
  padding: 0px 20px;
  margin-bottom: 5px;
  box-sizing: border-box;
  position: relative;
}

.bienvenida-container {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.mensaje-bienvenida {
  font: 300 19px 'Josefin Sans', sans-serif;
  color: #000;
  white-space: pre-line;
  text-align: center;
  margin-top:-170px;
  line-height: 2;
}

.versiculo-container {
  margin: 30px 20px 0 20px;
  text-align: center;
}

.versiculo-texto {
  font: 18px 'quote', sans-serif;
  line-height: 1.8;
  color: #333;
}

.versiculo-referencia-fija {
  font: 24px 'nombre', sans-serif;
  color: #070707;
  margin-top: 40px;
}

.letra-quince {
  font-family: 'british', cursive;
  font-size: 25px;
  color: #043b73;
}

.disco-group {
  position: absolute;
  pointer-events: none;
  z-index: 2;
}

.disco {
  width: 180px !important;
}

.estrellas {
  width: 100px;
  position: absolute;
  bottom: -35px;
  left: 0;
  transform: rotate(-10deg);
}

.disco1-group {
  top: -5%;
  right: -15%;
}

.disco2-group {
  top: 30%;
  left: -15%;
}

.disco3-group {
  bottom: -15%;
  left: -10%;
  z-index:10;
}
</style>